import { WarningTriangle } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from 'components/ui/alert';
import { Button } from 'components/ui/button';

interface SectionErrorProps {
  message: string;
  onRetry: () => void;
}

export const SectionError = ({ message, onRetry }: SectionErrorProps) => {
  const { t } = useTranslation();

  return (
    <Alert variant="destructive">
      <WarningTriangle aria-hidden="true" className="h-4 w-4" />
      <div className="flex flex-wrap items-center justify-between gap-3">
        <AlertDescription>{message}</AlertDescription>
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t('TRY_AGAIN', 'Try Again')}
        </Button>
      </div>
    </Alert>
  );
};
